"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScreenMode = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ArrowUpward_1 = __importDefault(require("@material-ui/icons/ArrowUpward"));
const ArrowForward_1 = __importDefault(require("@material-ui/icons/ArrowForward"));
const ForwardOutlined_1 = __importDefault(require("@material-ui/icons/ForwardOutlined"));
const menubar_context_1 = require("../../../composite/menubar/menubar-context");
const screen_mode_styles_1 = require("./screen-mode-styles");
/**
 * Screen mode switcher functionality.
 */
function useScreenMode() {
    const splitScreenRef = react_1.useRef(null);
    const { modifyItems } = react_1.useContext(menubar_context_1.MenubarContext);
    const classes = screen_mode_styles_1.useStyles();
    const intl = react_intl_1.useIntl();
    const menuItems = react_1.useMemo(() => [
        {
            label: intl.formatMessage({
                id: 'EAS_REPORTING_MENU_VIEW',
                defaultMessage: 'Zobrazení',
            }),
            items: [
                {
                    label: intl.formatMessage({
                        id: 'EAS_REPORTING_MENU_VIEW_DEFINITIONS',
                        defaultMessage: 'Výběr',
                    }),
                    keyShortcut: 'shift+right',
                    keyShortcutLabel: (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ForwardOutlined_1.default, { fontSize: "small", className: classes.shift }),
                        ' ',
                        react_1.default.createElement(ArrowForward_1.default, { fontSize: "small" }))),
                    onClick: () => {
                        var _a;
                        (_a = splitScreenRef.current) === null || _a === void 0 ? void 0 : _a.handleFullSizeLeft();
                    },
                },
                {
                    label: intl.formatMessage({
                        id: 'EAS_REPORTING_MENU_VIEW_SPLIT',
                        defaultMessage: 'Dělené',
                    }),
                    keyShortcut: 'shift+up',
                    keyShortcutLabel: (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ForwardOutlined_1.default, { fontSize: "small", className: classes.shift }),
                        ' ',
                        react_1.default.createElement(ArrowUpward_1.default, { fontSize: "small" }))),
                    onClick: () => {
                        var _a;
                        (_a = splitScreenRef.current) === null || _a === void 0 ? void 0 : _a.handleMoveToMiddle();
                    },
                },
                {
                    label: intl.formatMessage({
                        id: 'EAS_REPORTING_MENU_VIEW_DATA',
                        defaultMessage: 'Report',
                    }),
                    keyShortcut: 'shift+left',
                    keyShortcutLabel: (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ForwardOutlined_1.default, { fontSize: "small", className: classes.shift }),
                        ' ',
                        react_1.default.createElement(ArrowForward_1.default, { fontSize: "small", className: classes.back }))),
                    onClick: () => {
                        var _a;
                        (_a = splitScreenRef.current) === null || _a === void 0 ? void 0 : _a.handleFullSizeRight();
                    },
                },
            ],
        },
    ], [intl]);
    // adds items to menu
    react_1.useEffect(() => {
        modifyItems((items) => [...items, ...menuItems]);
        return () => {
            modifyItems((items) => items.filter((item) => !menuItems.includes(item)));
        };
    }, [menuItems, modifyItems]);
    return { splitScreenRef };
}
exports.useScreenMode = useScreenMode;
//# sourceMappingURL=screen-mode-hook.js.map